import { Trans, useTranslation } from "react-i18next";
import { Body, Headline, Title } from "sunday-component";
import { Col, Row } from "antd";
import { color } from "src/styles/globals";
import { useRouter } from "next/router";
import {
  FlexHorizontalContainer,
  FlexVerticalContainer,
  SectionContainer,
} from "../style/AffiliatePage.style";
import { ConsentButton, StepNumber } from "./TutorialStep.style";

const TutorialStep = () => {
  const { t } = useTranslation("affiliate");
  const router = useRouter();
  const { locale } = router;

  const onOpenConsent = () => {
    window.open(
      `https://static.easysunday.com/retail/affiliate/pdf/consent_tc_${locale}_20260615.pdf`,
      "_blank"
    );
  };
  const stepData = [
    {
      step: 1,
      title: t("tutorial.step1.title"),
      description: "tutorial.step1.description",
    },
    {
      step: 2,
      title: t("tutorial.step2.title"),
      description: "tutorial.step2.description",
    },
    {
      step: 3,
      title: t("tutorial.step3.title"),
      description: "tutorial.step3.description",
      render: () => (
        <ConsentButton onClick={onOpenConsent}>
          <Title level={7}>{t("tutorial.termsButton")}</Title>
        </ConsentButton>
      ),
    },
  ];
  return (
    <SectionContainer id="tutorial-step">
      <Headline level={6} style={{ marginBottom: "24px" }}>
        {t("tutorial.title")}
      </Headline>
      <Row gutter={[16, 16]}>
        {stepData.map((item) => (
          <Col key={item.step} lg={8}>
            <FlexHorizontalContainer key={item.step} columnGap="8px">
              <StepNumber>{item.step}</StepNumber>
              <FlexVerticalContainer rowGap="8px">
                <Title level={7}>{item.title}</Title>
                <Body style={{ color: color.charcoal09 }} level={7}>
                  <Trans
                    t={t}
                    i18nKey={item.description}
                    components={[
                      <a
                        key={0}
                        target="_blank"
                        rel="noreferrer"
                        href="https://static.easysunday.com/retail/affiliate/pdf/product_list_selling_point_th_20260615.pdf"
                      >
                        Hidden Text
                      </a>,
                    ]}
                  >
                    {t(item.description)}
                  </Trans>
                  {item.render && item.render()}
                </Body>
              </FlexVerticalContainer>
            </FlexHorizontalContainer>
          </Col>
        ))}
      </Row>
    </SectionContainer>
  );
};
export default TutorialStep;
